import React from 'react'
import HeaderBlock from './HeaderBlock'
import OneColWrapper from '../technical/OneColWrapper'
import Richtext from '../atoms/Richtext'
import SbEditable from 'storyblok-react'

const CenteredTextBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="centered-text-block">
        <HeaderBlock className="pb-2" block={block} />

        <OneColWrapper
          className={`text-center ${block.big_text === true ? 'big-text' : ''}`}
          block={block}
        >
          <Richtext text={block.text} />
        </OneColWrapper>
      </section>
    </SbEditable>
  )
}

export default CenteredTextBlock
